!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Apply slick.js slider to action-box-list.
   */
  Drupal.behaviors.actionBoxList = {
    attach: context => {
      /**
       * Apply/remove slick.
       * @param {jQuery} $actionBoxList A list of items to apply slick.
       * @returns {void}
       */
      function setSlick($actionBoxList) {
        if ($(window).width() < 768) {
          $actionBoxList.not('.slick-initialized').slick({
            speed: 300,
            mobileFirst: true,
            adaptiveHeight: true,
            adaptiveWidth: true,
            prevArrow:
              '<button class=\'action-box-list-nav action-box-list-nav--prev\' aria-label=\'Previous\' type=\'button\' style=\'display: flex;\'><i class=\'fa-solid fa-angle-left\'></i></button>', // eslint-disable-line max-len
            nextArrow:
              '<button class=\'action-box-list-nav action-box-list-nav--next\' aria-label=\'Next\' type=\'button\' style=\'display: flex;\'><i class=\'fa-solid fa-angle-right\'></i></button>', // eslint-disable-line max-len
          });
        }
        else {
          // Revert to original action-box-list.
          $actionBoxList.hasClass('.slick-initialized') &&
            $actionBoxList.slick('unslick');
        }
      }

      $(once('actionBoxList', '.js-action-box-list', context))
        .each(function() {
          let $actionBoxList = $(this);
          setSlick($actionBoxList);

          let r;
          $(window).resize(function() {
            setSlick($actionBoxList);
            clearTimeout(r);
            r = setTimeout(function() {
              setSlick($actionBoxList);
            }, 500);
          });
        });
    },
  };
})(document, Drupal, jQuery, once);
